/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/protectionStatusMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a ProtectionStatus. */
export class ProtectionStatus {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a ProtectionStatus.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Calls Consumer Security Api Manager to return the specific device by its deviceId and return the
   * health status of the device.
   * @summary Gets the device health status based on the deviceId provided.
   * @param deviceId
   * @param [options] The optional parameters
   * @returns Promise<Models.ProtectionStatusGetDeviceHealthStatusResponse>
   */
  getDeviceHealthStatus(deviceId: string, options?: coreHttp.RequestOptionsBase): Promise<Models.ProtectionStatusGetDeviceHealthStatusResponse>;
  /**
   * @param deviceId
   * @param callback The callback
   */
  getDeviceHealthStatus(deviceId: string, callback: coreHttp.ServiceCallback<Models.DeviceProtectionStatus>): void;
  /**
   * @param deviceId
   * @param options The optional parameters
   * @param callback The callback
   */
  getDeviceHealthStatus(deviceId: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.DeviceProtectionStatus>): void;
  getDeviceHealthStatus(deviceId: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.DeviceProtectionStatus>, callback?: coreHttp.ServiceCallback<Models.DeviceProtectionStatus>): Promise<Models.ProtectionStatusGetDeviceHealthStatusResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        options
      },
      getDeviceHealthStatusOperationSpec,
      callback) as Promise<Models.ProtectionStatusGetDeviceHealthStatusResponse>;
  }

  /**
   * Calls Consumer Security Api Manager to update a the health status of specific device based on
   * the information
   * @summary Updates the device health status based on the information and deviceId provided.
   * @param deviceId
   * @param [options] The optional parameters
   * @returns Promise<Models.ProtectionStatusUpdateDeviceHealthStatusResponse>
   */
  updateDeviceHealthStatus(deviceId: string, options?: Models.ProtectionStatusUpdateDeviceHealthStatusOptionalParams): Promise<Models.ProtectionStatusUpdateDeviceHealthStatusResponse>;
  /**
   * @param deviceId
   * @param callback The callback
   */
  updateDeviceHealthStatus(deviceId: string, callback: coreHttp.ServiceCallback<Models.DeviceProtectionStatus>): void;
  /**
   * @param deviceId
   * @param options The optional parameters
   * @param callback The callback
   */
  updateDeviceHealthStatus(deviceId: string, options: Models.ProtectionStatusUpdateDeviceHealthStatusOptionalParams, callback: coreHttp.ServiceCallback<Models.DeviceProtectionStatus>): void;
  updateDeviceHealthStatus(deviceId: string, options?: Models.ProtectionStatusUpdateDeviceHealthStatusOptionalParams | coreHttp.ServiceCallback<Models.DeviceProtectionStatus>, callback?: coreHttp.ServiceCallback<Models.DeviceProtectionStatus>): Promise<Models.ProtectionStatusUpdateDeviceHealthStatusResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        options
      },
      updateDeviceHealthStatusOperationSpec,
      callback) as Promise<Models.ProtectionStatusUpdateDeviceHealthStatusResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getDeviceHealthStatusOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/devices/{deviceId}/status",
  urlParameters: [
    Parameters.deviceId
  ],
  responses: {
    200: {
      bodyMapper: Mappers.DeviceProtectionStatus
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const updateDeviceHealthStatusOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/me/devices/{deviceId}/status",
  urlParameters: [
    Parameters.deviceId
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.DeviceProtectionStatus
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.DeviceProtectionStatus
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
